// import React, { useState } from "react";
// import {
//   IconChevronDown,
//   IconChevronUp,
//   IconChevronRight,
//   IconDotsVertical,
//   IconX,
//   IconSearch,
//   IconBuildingWarehouse,
//   IconArrowsLeftRight,
//   IconReplaceUser,
//   IconPrinter,
// } from "@tabler/icons-react";
// import DRSShipmentPanel from "./DRSShipmentPanel";
// import SwapGenrateModal from "./SwapGenrateModal";
// import SwapDriverModal from "./SwapDriverModal";
// import { useForm, Controller } from "react-hook-form";
// import {
//   useFetchDRSDetailsData,
//   useDRSShipmentRevertStatusMutation,
//   useDRSDownloadMutation,
// } from "../../../apis/drsApi";
// import { useWarehouseListData } from "../../../apis/warehouseApi";
// import useDebounce from "../../../utilities/useDebounce";
// import ListView from "../../../components/common/ListView";
// import toast from "react-hot-toast";
// import { T } from "../../../context/LanguageContext";

// type DrsData = {
//   id: number;
//   drsId: string;
//   driver: string;
//   driverCode?: string;
//   city: string;
//   warehouseId?: string;
//   warehouseName?: string;
//   routeCode: string;
//   createdAt: string;
//   createdBy: string;
//   codAmount: string;
//   shipments: string;
//   ordersDelivered: string;
//   ordersNotDelivered: string;
//   ordersProcess: string;
//   collectedAmount: string;
//   receiveInWarehouse: string;
//   outForDelivery: string;
//   status: string;
// };

// const formatStatus = (status: string) => {
//   return status
//     ?.toLowerCase()
//     .split("_")
//     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(" ");
// };

// const DRSExpandedShipments: React.FC<{
//   drsId: string;
//   swaps?: any[];
//   onRiw?: () => void;
//   onSwap?: () => void;
//   swapRequest?: any;
//   onOpenSwapAssign?: (swapReq: any) => void;
//   openSwapMenuDrsId?: string | null;
//   setOpenSwapMenuDrsId?: (id: string | null) => void;
//   swapMenuRef?: React.RefObject<HTMLDivElement | null>;
//   drsItemId?: string;
//   selectedRows: string[];
//   setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
//   selectedLines: string[];
//   setSelectedLines: React.Dispatch<React.SetStateAction<string[]>>;
//   handleSaveAllReturns?: () => void;
//   isShipmentReturnPending?: boolean;
//   handleGenerateSwap?: () => void;
//   isSwapGeneratePending?: boolean;
// }> = ({
//   drsId,
//   swaps = [],
//   onRiw,
//   onSwap,
//   swapRequest,
//   onOpenSwapAssign,
//   openSwapMenuDrsId,
//   setOpenSwapMenuDrsId,
//   swapMenuRef,
//   drsItemId,
//   selectedRows,
//   setSelectedRows,
//   selectedLines,
//   setSelectedLines,
//   handleSaveAllReturns,
//   isShipmentReturnPending,
//   handleGenerateSwap,
//   isSwapGeneratePending,
// }) => {
//   const [searchText, setSearchText] = useState("");
//   const [showSearch, setShowSearch] = useState(false);
//   const [openMenuId, setOpenMenuId] = useState<string | null>(null);
//   const debouncedSearch = useDebounce(searchText.trim().toLowerCase(), 400);

//   const { data, isLoading, refetch } = useFetchDRSDetailsData(drsId, "DL");
//   const { mutate: revertStatus, isPending: isRevertStatusPending } =
//     useDRSShipmentRevertStatusMutation();

//   const shipments = React.useMemo(() => {
//     return data?.drs?.[0]?.shipments || [];
//   }, [data]);

//   const swapForShipment = React.useMemo(() => {
//     const map: Record<
//       string,
//       {
//         swapShortId: string;
//         status: string;
//         acceptReqDriverName?: string;
//         rawSwap?: any;
//       }
//     > = {};
//     if (swaps && Array.isArray(swaps)) {
//       swaps.forEach((swap: any) => {
//         if (
//           swap.oldDrsShortId === drsId &&
//           swap.shipmentIds &&
//           Array.isArray(swap.shipmentIds)
//         ) {
//           swap.shipmentIds.forEach((sid: string) => {
//             map[sid] = {
//               swapShortId: swap.swapShortId,
//               status: swap.status,
//               acceptReqDriverName: swap.acceptReqDriverName,
//               rawSwap: swap,
//             };
//           });
//         }
//       });
//     }
//     return map;
//   }, [swaps, drsId]);

//   const filteredShipments = React.useMemo(() => {
//     if (!shipments) return [];
//     if (!debouncedSearch) return shipments;
//     return shipments.filter((shipment: any) => {
//       const awb = shipment.awbNumber?.toLowerCase() || "";
//       const receiverName = shipment.receiverName?.toLowerCase() || "";
//       const receiverCity = shipment.receiverCity?.toLowerCase() || "";
//       const receiverDistrict = shipment.receiverDistrict?.toLowerCase() || "";
//       return (
//         awb.includes(debouncedSearch) ||
//         receiverName.includes(debouncedSearch) ||
//         receiverCity.includes(debouncedSearch) ||
//         receiverDistrict.includes(debouncedSearch)
//       );
//     });
//   }, [shipments, debouncedSearch]);

//   const isNotDeliveredStatus = (status: string) => {
//     const s = (status || "").toUpperCase();
//     return s === "NOT_DELIVERED" || s === "RETURN" || s === "RETURNED";
//   };

//   const isEligibleForSwap = (s: any) => {
//     const normStatus = (s.status || "").toUpperCase();
//     const swapInfo = swapForShipment[s.id];
//     const hasActiveSwap =
//       swapInfo?.status === "REQUEST" ||
//       swapInfo?.status === "ACCEPTED" ||
//       s.isSwapped;
//     return normStatus === "OUT_FOR_DELIVERY" && !hasActiveSwap;
//   };

//   const selectedShipments = React.useMemo(() => {
//     return shipments.filter((s: any) => selectedRows.includes(s.id));
//   }, [shipments, selectedRows]);

//   const isRiwActive = React.useMemo(() => {
//     return (
//       selectedRows.length > 0 &&
//       selectedShipments.every((s: any) => isNotDeliveredStatus(s.status))
//     );
//   }, [selectedRows, selectedShipments]);

//   const riwTooltip = isRiwActive
//     ? "Dispatch OFD / RIW"
//     : "Select not delivered AWB";

//   const isSwapActive = React.useMemo(() => {
//     return (
//       selectedLines.length > 0 &&
//       selectedLines.every((id: string) => {
//         const s = shipments.find((x: any) => x.id === id);
//         return s && isEligibleForSwap(s);
//       })
//     );
//   }, [selectedLines, shipments, swapForShipment]);

//   const swapTooltip = isSwapActive ? "Generate Swap" : "Select AWB to Swap";

//   const isAssignDriverActive = React.useMemo(() => {
//     if (selectedRows.length === 0) return false;
//     return selectedRows.every((id: string) => {
//       const swapInfo = swapForShipment[id];
//       return swapInfo?.status === "REQUEST";
//     });
//   }, [selectedRows, swapForShipment]);

//   const assignDriverTooltip = React.useMemo(() => {
//     if (selectedRows.length === 0) {
//       return "Select swap request AWB";
//     }
//     const hasNonSwap = selectedRows.some((id: string) => {
//       const swapInfo = swapForShipment[id];
//       return swapInfo?.status !== "REQUEST";
//     });
//     if (hasNonSwap) {
//       return "Only swap req shipment can be assign driver";
//     }
//     return "Swap Driver / Assign Driver";
//   }, [selectedRows, swapForShipment]);

//   const showSwapDriverButton = React.useMemo(() => {
//     if (swapRequest?.status !== "REQUEST") return false;
//     return (
//       selectedRows.length > 0 &&
//       selectedRows.some(
//         (id: string) => swapForShipment[id]?.status === "REQUEST",
//       )
//     );
//   }, [swapRequest, selectedRows, swapForShipment]);

//   const handleRevertStatus = (shipmentId: string, shipmentStatus: string) => {
//     if (!shipmentId || shipmentId.trim() === "") {
//       toast.error("Invalid shipment ID");
//       return;
//     }
//     if (shipmentStatus === "DELIVERED" || shipmentStatus === "NOT_DELIVERED") {
//       toast.error(`Cannot revert ${shipmentStatus.replace(/_/g, " ")} orders`);
//       return;
//     }
//     if (!data?.drs?.[0]?.id) {
//       toast.error("DRS information is not available");
//       return;
//     }
//     setOpenMenuId(null);
//     const payload = { drsId: data?.drs?.[0]?.id, shipments: [shipmentId] };
//     revertStatus(payload, {
//       onSuccess: (res: any) => {
//         refetch();
//         toast.success(res?.message || "Status reverted successfully");
//       },
//       onError: (error: any) => {
//         console.error(error);
//         const errorMessage =
//           error?.response?.data?.error?.message ||
//           error?.response?.data?.message ||
//           error?.message ||
//           "Failed to revert status.";
//         toast.error(errorMessage);
//       },
//     });
//   };

//   if (isLoading) {
//     return (
//       <div className="p-8 text-center text-sm font-medium text-gray-500">
//         Loading shipments...
//       </div>
//     );
//   }

//   return (
//     <div className="overflow-visible">
//       {/* Table header row — styled like Order table */}
//       <div className="flex items-center justify-between px-4 py-2.5 bg-white border-b border-[#E5E5E5]">
//         {/* Left: title + swap badge */}
//         <div className="flex items-center gap-3">
//           <h3 className="text-sm font-bold text-[#212121]">Shipments List</h3>
//           {swapRequest && (
//             <span className="px-2 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200 text-[10px] font-bold uppercase tracking-wider">
//               SWAP: {swapRequest.status}
//             </span>
//           )}
//         </div>

//         {/* Right: slide-open search + action buttons */}
//         <div className="flex items-center gap-2">
//           {/* Slide-open Search — same as DRS list */}
//           <div className="relative group">
//             <div
//               onClick={() => {
//                 if (!showSearch) setShowSearch(true);
//               }}
//               className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 shrink-0 ${
//                 showSearch
//                   ? "w-56 px-2 cursor-default"
//                   : "w-8 justify-center cursor-pointer"
//               }`}
//             >
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setShowSearch(!showSearch);
//                 }}
//                 className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
//               >
//                 <IconSearch size={16} stroke={2.5} />
//               </button>
//               {showSearch && (
//                 <>
//                   <input
//                     type="text"
//                     value={searchText}
//                     onChange={(e) => setSearchText(e.target.value)}
//                     placeholder="Search..."
//                     autoFocus
//                     className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none border-0 focus:ring-0 focus:outline-none p-0"
//                   />
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setSearchText("");
//                       setShowSearch(false);
//                     }}
//                     className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
//                     title="Clear & Close"
//                   >
//                     <IconX size={14} stroke={2.5} />
//                   </button>
//                 </>
//               )}
//             </div>
//             {!showSearch && (
//               <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
//                 Search
//               </div>
//             )}
//           </div>

//           {/* Dispatch OFD / RIW button */}
//           {handleSaveAllReturns && (
//             <div className="relative group">
//               <button
//                 disabled={!isRiwActive || isShipmentReturnPending}
//                 onClick={handleSaveAllReturns}
//                 className="h-8 w-8 flex items-center justify-center bg-white border border-slate-200 text-slate-700 hover:bg-[#FBD037] hover:border-[#FBD037] hover:text-[#212121] rounded-md shadow-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-slate-700 disabled:hover:border-slate-200"
//               >
//                 <IconBuildingWarehouse
//                   size={16}
//                   stroke={2.5}
//                   className={isShipmentReturnPending ? "animate-pulse" : ""}
//                 />
//               </button>
//               <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
//                 {riwTooltip}
//               </div>
//             </div>
//           )}

//           {/* Generate Swap button */}
//           {handleGenerateSwap && (
//             <div className="relative group">
//               <button
//                 disabled={!isSwapActive || isSwapGeneratePending}
//                 onClick={handleGenerateSwap}
//                 className="h-8 w-8 flex items-center justify-center bg-white border border-slate-200 text-slate-700 hover:bg-[#FBD037] hover:border-[#FBD037] hover:text-[#212121] rounded-md shadow-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-slate-700 disabled:hover:border-slate-200"
//               >
//                 <IconArrowsLeftRight
//                   size={16}
//                   stroke={2.5}
//                   className={isSwapGeneratePending ? "animate-pulse" : ""}
//                 />
//               </button>
//               <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
//                 {swapTooltip}
//               </div>
//             </div>
//           )}
//           {/* Swap Driver button */}
//           {showSwapDriverButton && onOpenSwapAssign && (
//             <div className="relative group">
//               <button
//                 disabled={!isAssignDriverActive}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   const firstSelectedId = selectedRows[0];
//                   const swapInfo = swapForShipment[firstSelectedId];
//                   if (swapInfo && swapInfo.rawSwap) {
//                     onOpenSwapAssign(swapInfo.rawSwap);
//                   } else if (swapRequest) {
//                     onOpenSwapAssign(swapRequest);
//                   }
//                 }}
//                 className="h-8 w-8 flex items-center justify-center bg-white border border-slate-200 text-slate-700 hover:bg-[#FBD037] hover:border-[#FBD037] hover:text-[#212121] rounded-md shadow-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-slate-700 disabled:hover:border-slate-200"
//               >
//                 <IconReplaceUser size={16} stroke={2.5} />
//               </button>
//               <div className="absolute bottom-full mb-1.5 right-0 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
//                 {assignDriverTooltip}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <ListView
//         scrollbarClassName="custom-scrollbar"
//         data={filteredShipments}
//         columns={[
//           {
//             label: (
//               <label className="relative flex items-center justify-center cursor-pointer select-none">
//                 <input
//                   type="checkbox"
//                   checked={
//                     filteredShipments.length > 0 &&
//                     filteredShipments.every((s: any) =>
//                       selectedRows.includes(s.id),
//                     )
//                   }
//                   onChange={(e) => {
//                     const ids = filteredShipments.map((s: any) => s.id);
//                     if (e.target.checked) {
//                       setSelectedRows(ids);
//                       setSelectedLines(ids);
//                     } else {
//                       setSelectedRows([]);
//                       setSelectedLines([]);
//                     }
//                   }}
//                   className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                 />
//                 <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                   ✓
//                 </span>
//               </label>
//             ),
//             render: (row: any) => (
//               <div className="flex items-center justify-center">
//                 <label className="relative flex items-center cursor-pointer select-none">
//                   <input
//                     type="checkbox"
//                     checked={selectedRows.includes(row.id)}
//                     onChange={() => {
//                       const isChecked = selectedRows.includes(row.id);
//                       if (isChecked) {
//                         setSelectedRows((prev) =>
//                           prev.filter((id) => id !== row.id),
//                         );
//                         setSelectedLines((prev) =>
//                           prev.filter((id) => id !== row.id),
//                         );
//                       } else {
//                         setSelectedRows((prev) => [...prev, row.id]);
//                         setSelectedLines((prev) => [...prev, row.id]);
//                       }
//                     }}
//                     className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                   />
//                   <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                     ✓
//                   </span>
//                 </label>
//               </div>
//             ),
//           },
//           { label: "#", render: (_: any, i: number) => i + 1 },
//           {
//              label: <T>AWB No.</T>,
//             render: (s: any) => {
//               const swapInfo = swapForShipment[s.id];
//               return (
//                 <div className="flex flex-col items-center gap-1 py-1">
//                   <span className="font-bold text-[#212121]">
//                     {s.awbNumber}
//                   </span>
//                   {swapInfo && (
//                     <div className="flex flex-col items-center gap-0.5">
//                       <span
//                         className={`inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider border leading-none ${
//                           swapInfo.status === "REQUEST"
//                             ? "bg-amber-50 text-amber-700 border-amber-200"
//                             : swapInfo.status === "ACCEPTED"
//                               ? "bg-emerald-50 text-emerald-700 border-emerald-200"
//                               : "bg-gray-100 text-gray-700 border-gray-200"
//                         }`}
//                       >
//                         Swap: {swapInfo.status}
//                       </span>
//                       {swapInfo.acceptReqDriverName && (
//                         <span className="text-[9px] text-gray-500 font-medium leading-none">
//                           &rarr; {swapInfo.acceptReqDriverName}
//                         </span>
//                       )}
//                     </div>
//                   )}
//                   {s.isSwapped && (
//                     <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider border leading-none bg-emerald-100 text-emerald-800 border-emerald-300">
//                       SWAPPED
//                     </span>
//                   )}
//                 </div>
//               );
//             },
//           },
//            { label: <T>Origin</T>, render: (c: any) => c.senderCity },
//           {
//              label: <T>Destination</T>,
//             render: (s: any) => (
//               <div className="text-center">
//                 <div className="text-xs font-bold text-[#212121]">
//                   {s.receiverCity || s.receiverCityName || ""}
//                   {s.receiverCountry || s.receiverCountryName
//                     ? `, ${s.receiverCountry || s.receiverCountryName}`
//                     : ""}
//                 </div>
//                 <div className="text-[9px] text-slate-400 font-bold mt-1">
//                   Dist: {s.receiverDistrict || s.receiverDistrictName || "N/A"}
//                 </div>
//               </div>
//             ),
//           },
//           {
//              label: <T>Payment</T>,
//             render: (s: any) => (
//               <div className="text-center">
//                 <span
//                   className={`px-1.5 py-0.5 rounded text-[10px] font-black tracking-wider uppercase border inline-block max-w-full ${
//                     s.paymentType === "COD"
//                       ? "bg-amber-50 border-amber-200 text-amber-800"
//                       : "bg-emerald-50 border-emerald-200 text-emerald-800"
//                   }`}
//                 >
//                   {s.paymentType === "COD"
//                     ? `COD:${s.codAmount ?? 0}`
//                     : "CC: PAID"}
//                 </span>
//               </div>
//             ),
//           },
//           {
//              label: <T>Status</T>,
//             render: (c: any) => {
//               const normStatus = (c.status || "").toUpperCase();
//               let badgeClasses =
//                 "bg-slate-50 border border-slate-200 text-slate-600";
//               let label = formatStatus(c.status);

//               if (normStatus === "DELIVERED") {
//                 badgeClasses =
//                   "bg-lime-50 border border-lime-300 text-lime-800";
//                 label = "Delivered";
//               } else if (normStatus === "OUT_FOR_DELIVERY") {
//                 badgeClasses =
//                   "bg-orange-50 border border-orange-300 text-orange-800";
//                 label = "Out For Delivery";
//               } else if (normStatus === "DELETED") {
//                 badgeClasses =
//                   "bg-rose-50 border border-rose-300 text-rose-800";
//                 label = "Deleted";
//               } else if (
//                 normStatus === "RETURN" ||
//                 normStatus === "NOT_DELIVERED" ||
//                 normStatus === "RETURNED"
//               ) {
//                 badgeClasses =
//                   "bg-pink-50 border border-pink-300 text-pink-800";
//                 label = "Returned";
//               }

//               return (
//                 <div className="text-center">
//                   <span
//                     className={`border py-0.5 rounded-full text-[10px] font-extrabold tracking-wide inline-block text-center px-2 truncate max-w-full align-middle ${badgeClasses}`}
//                   >
//                     {label}
//                   </span>
//                 </div>
//               );
//             },
//           },
//           {
//              label: <T>Revert Status</T>,
//             render: (c: any) => {
//               if (c.status === "DELIVERED" || c.status === "NOT_DELIVERED") {
//                 return null;
//               }

//               return (
//                 <div className="text-center">
//                   <button
//                     onClick={() => handleRevertStatus(c.id, c.status)}
//                     disabled={isRevertStatusPending}
//                     className="px-3 py-1.5 bg-rose-50 hover:bg-rose-100 border border-rose-200 text-rose-600  text-xs font-bold transition shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
//                   >
//                     {isRevertStatusPending ? "Reverting..." : "Revert"}
//                   </button>
//                 </div>
//               );
//             },
//           },
//         ]}
//       />
//     </div>
//   );
// };

// type Props = {
//   data: DrsData[];
//   onRiw: (item: DrsData) => void;
//   OnSwap: (item: DrsData) => void;
//   onEdit?: (item: DrsData) => void;
//   selectedData: any[];
//   setSelectedData: React.Dispatch<React.SetStateAction<any[]>>;
//   isDownloadMode: boolean;
//   onExpandRow?: (drsId: string | null) => void;
//   swaps?: any[];
//   onOpenSwapAssign?: (swapReq: any) => void;
//   isFormOpen?: boolean;

//   // Sidebar props
//   openFlet?: boolean;
//   swap?: boolean;
//   openAssign?: boolean;
//   activeDrsId?: string;
//   activeDrsShortId?: string;
//   swapRequestData?: any;

//   returnForm?: any;
//   selectedRows?: string[];
//   setSelectedRows?: any;
//   savedReturns?: any;
//   setSavedReturns?: any;
//   isShipmentReturnPending?: boolean;
//   handleSaveAllReturns?: () => void;
//   openFletToggleModal?: () => void;

//   register?: any;
//   errors?: any;
//   clearErrors?: any;
//   setValue?: any;
//   control?: any;
//   watch?: any;
//   selectedLines?: string[];
//   setSelectedLines?: any;
//   isSwapGeneratePending?: boolean;
//   handleGenerateSwap?: () => void;
//   openSwapGenrateModal?: () => void;

//   refetchMainList?: () => void;
//   refetchSwapsList?: () => void;
//   onCloseAssign?: () => void;
// };

// const formatDateReadable = (dateStr: string) => {
//   if (!dateStr) return "—";
//   try {
//     const d = new Date(dateStr);
//     const day = d.getDate();
//     const months = [
//       "Jan",
//       "Feb",
//       "Mar",
//       "Apr",
//       "May",
//       "Jun",
//       "Jul",
//       "Aug",
//       "Sep",
//       "Oct",
//       "Nov",
//       "Dec",
//     ];
//     const month = months[d.getMonth()];
//     const year = d.getFullYear();
//     return `${day} ${month} ${year}`;
//   } catch (e) {
//     return dateStr;
//   }
// };

// const DRSExpandableList: React.FC<Props> = ({
//   data = [],
//   onRiw,
//   OnSwap,
//   onEdit,
//   selectedData,
//   setSelectedData,
//   isDownloadMode,
//   onExpandRow,
//   swaps = [],
//   onOpenSwapAssign,
//   isFormOpen = false,

//   openFlet = false,
//   swap: openSwap = false,
//   openAssign = false,
//   activeDrsId = "",
//   activeDrsShortId = "",
//   swapRequestData,

//   returnForm,
//   selectedRows = [],
//   setSelectedRows,
//   savedReturns = {},
//   setSavedReturns,
//   isShipmentReturnPending = false,
//   handleSaveAllReturns,
//   openFletToggleModal,

//   register,
//   errors,
//   clearErrors,
//   setValue,
//   control,
//   watch,
//   selectedLines = [],
//   setSelectedLines,
//   isSwapGeneratePending = false,
//   handleGenerateSwap,
//   openSwapGenrateModal,

//   refetchMainList,
//   refetchSwapsList,
//   onCloseAssign,
// }) => {
//   const { data: warehousesData } = useWarehouseListData();
//   const downloadDrs = useDRSDownloadMutation();
//   const [printingDrsId, setPrintingDrsId] = useState<string | null>(null);

//   const handlePrintDrs = (drsId: string) => {
//     setPrintingDrsId(drsId);
//     downloadDrs.mutate(drsId, {
//       onSuccess: () => {
//         toast.success("DRS Sheet PDF downloaded successfully");
//         setPrintingDrsId(null);
//       },
//       onError: (err: any) => {
//         const errMsg = err?.message || "Failed to download DRS Sheet";
//         toast.error(errMsg);
//         setPrintingDrsId(null);
//       },
//     });
//   };

//   const getWarehouseName = (warehouseId?: string) => {
//     if (!warehouseId || !warehousesData?.warehouses) return "—";
//     const found = warehousesData.warehouses.find(
//       (w: any) => w.id === warehouseId,
//     );
//     return found ? found.name : "—";
//   };

//   const [expandedRow, setExpandedRow] = useState<string | null>(null);
//   const [openSwapMenuDrsId, setOpenSwapMenuDrsId] = useState<string | null>(
//     null,
//   );
//   const swapMenuRef = React.useRef<HTMLDivElement>(null);
//   const [openActionMenuId, setOpenActionMenuId] = useState<string | null>(null);
//   const actionMenuRef = React.useRef<HTMLDivElement>(null);

//   React.useEffect(() => {
//     function handleClickOutside(event: MouseEvent) {
//       if (
//         openSwapMenuDrsId &&
//         swapMenuRef.current &&
//         !swapMenuRef.current.contains(event.target as Node)
//       ) {
//         setOpenSwapMenuDrsId(null);
//       }
//       if (
//         openActionMenuId &&
//         actionMenuRef.current &&
//         !actionMenuRef.current.contains(event.target as Node)
//       ) {
//         setOpenActionMenuId(null);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [openSwapMenuDrsId, openActionMenuId]);

//   const handleRowClick = (item: DrsData) => {
//     const isExpanded = expandedRow === item.drsId;
//     const nextVal = isExpanded ? null : item.drsId;
//     setExpandedRow(nextVal);
//     if (onExpandRow) {
//       onExpandRow(nextVal);
//     }
//   };

//   const handleRowSelect = (item: DrsData, checked: boolean) => {
//     if (checked) {
//       setSelectedData((prev) => {
//         if (!prev.some((d) => d.drsId === item.drsId)) {
//           return [...prev, item];
//         }
//         return prev;
//       });
//     } else {
//       setSelectedData((prev) => prev.filter((d) => d.drsId !== item.drsId));
//     }
//   };

//   const getStatusColor = (status: string) => {
//     switch (status) {
//       case "ACTIVE":
//         return "bg-green-50 text-green-700 border-green-300 hover:bg-green-100";
//       case "CLOSED":
//         return "bg-slate-50 text-slate-700 border-slate-300 hover:bg-slate-100";
//       default:
//         return "bg-blue-50 text-blue-700 border-blue-300 hover:bg-blue-100";
//     }
//   };

//   return (
//     <div className="w-full overflow-x-auto custom-scrollbar">
//       <div
//         className={`flex flex-col ${isFormOpen ? "min-w-[760px]" : "md:min-w-[1150px] min-w-[850px]"}`}
//       >
//         {/* Table Header Row */}
//         <div className="flex items-center gap-4 px-6 border border-dashed text-xs font-bold text-[#212121] uppercase  bg-[#FCFDF8] select-none">
//           <div className="w-8 shrink-0 border-l border-dashed"></div>{" "}
//           {/* Space for expand chevron */}
//           {isDownloadMode && (
//             <div className="w-6 shrink-0 flex border-l border-dashed  items-center justify-center">
//               SELECT
//             </div>
//           )}
//           <div className="flex-1 text-left min-w-[90px] px-2 pt-3 pb-2 border-r border-dashed border-gray-200  ">
//             DRS
//           </div>
//           <div className="flex-[1.2] text-left min-w-[130px] px-2 pt-3 pb-2 border-r border-dashed border-gray-200 ">
//             DRIVER
//           </div>
//           {!isFormOpen && (
//             <div className="hidden md:block flex-1 text-left min-w-[90px] px-2 pt-3 pb-2 border-r border-dashed border-gray-200 ">
//               CITY
//             </div>
//           )}
//           {!isFormOpen && (
//             <div className="hidden lg:block flex-[0.8] text-left min-w-[90px] px-2 pt-3 pb-2 border-r border-dashed border-gray-200 ">
//               ROUTE CODE
//             </div>
//           )}
//           {!isFormOpen && (
//             <div className="hidden lg:block flex-[1.2] text-left min-w-[120px] px-2 pt-3 pb-2 ">
//               WAREHOUSE
//             </div>
//           )}
//           <div className="flex-[2] text-center min-w-[200px] flex flex-col gap-0.5 border-l border-r border-dashed border-gray-200 ">
//             <span className="font-bold text-[10px] border-b border-dashed border-gray-200">
//               SHIPMENT
//             </span>
//             <div className="flex justify-between text-[9px] text-gray-500 font-extrabold">
//               <span className="px-2 border-r border-dashed border-gray-200">
//                 TOTAL
//               </span>
//               <span className="px-2">DEL</span>
//               <span className="px-2  border-l border-dashed border-gray-200">RET</span>
//               <span className="px-2 border-l border-dashed border-gray-200">IN PROCESS</span>
//             </div>
//           </div>
//           {!isFormOpen && (
//             <div className="flex-[0.8] text-center min-w-[80px] px-2 pt-3 pb-2 ">COD</div>
//           )}
//           {!isFormOpen && (
//             <div className="flex-[0.9] text-center min-w-[90px] px-2 pt-3 pb-2 border-l  border-dashed border-gray-200 ">DATE</div>
//           )}
//           {!isFormOpen && (
//             <div className="flex-[0.9] text-center min-w-[90px] px-2 pt-3 pb-2 border-l border-r border-dashed border-gray-200 ">
//               Created By
//             </div>
//           )}
//           <div className="flex-[0.8] text-center min-w-[90px] px-2 pt-3 pb-2 border-r border-dashed border-gray-200 ">STATUS</div>
//           <div className="flex-[0.8] text-center min-w-[100px] px-2">PRINT</div>
//         </div>

//         {data.map((item, index) => {
//           const isExpanded = expandedRow === item.drsId;
//           const totalShipments = item.shipments?.length || 0;
//           const del = parseInt(item.ordersDelivered) || 0;
//           const nd = parseInt(item.ordersNotDelivered) || 0;
//           const ofd = totalShipments - (del + nd); // Approx
//           const codTotal = item.codAmount || 0;
//           const swapRequest = swaps?.find(
//             (s: any) => s.oldDrsShortId === item.drsId,
//           );

//           return (
//             <div key={item.id} className="">
//               {/* Header / Summary Row */}
//               <div
//                 className="flex items-center gap-4 cursor-pointer hover:bg-gray-50 p-4 text-sm text-[#212121]/70"
//                 onClick={() => handleRowClick(item)}
//               >
//                 {/* Expand Arrow Area */}
//                 {/* <div
//                   className="w-8 shrink-0 flex items-center justify-center"
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <button
//                     onClick={() => handleRowClick(item)}
//                     className="flex h-8 w-8 items-center justify-center  border border-[#ECECEC] bg-[#F7F6F2] hover:bg-gray-100 transition"
//                   >
//                     {isExpanded ? (
//                       <IconChevronUp size={16} className="text-[#404040]" />
//                     ) : (
//                       <IconChevronDown size={16} className="text-[#404040]" />
//                     )}
//                   </button>
//                 </div> */}

//                 {/* Checkbox (if download mode is enabled) */}
//                 {isDownloadMode && (
//                   <div
//                     className="w-6 shrink-0 flex items-center justify-center"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <label className="relative flex items-center cursor-pointer">
//                       <input
//                         type="checkbox"
//                         checked={selectedData.some(
//                           (d) => d.drsId === item.drsId,
//                         )}
//                         onChange={(e) =>
//                           handleRowSelect(item, e.target.checked)
//                         }
//                         className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] checked:text-white"
//                       />
//                       <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                         ✓
//                       </span>
//                     </label>
//                   </div>
//                 )}

//                 {/* DRS ID */}
//                 <div className=" px-2 flex-1 text-left min-w-[90px] font-medium text-[#212121]/70">
//                   {item.drsId}
//                 </div>

//                 {/* Driver Name & Code */}
//                 <div className="flex-[1.2] text-left min-w-[130px] flex flex-col justify-center">
//                   <span className="font-medium text-[#212121]/70">
//                     {item.driver || "—"}
//                   </span>
//                   {item.driverCode && (
//                     <span className="text-[10px] text-slate-500 font-medium mt-0.5">
//                       Code: {item.driverCode}
//                     </span>
//                   )}
//                 </div>

//                 {/* City */}
//                 {!isFormOpen && (
//                   <div className="hidden md:block flex-1 text-left min-w-[90px] font-medium text-[#212121]/70">
//                     {item.city || "—"}
//                   </div>
//                 )}

//                 {/* Route Code */}
//                 {!isFormOpen && (
//                   <div className="hidden lg:block flex-[0.8] text-left min-w-[90px] font-medium text-[#212121]/70">
//                     {item.routeCode || "—"}
//                   </div>
//                 )}

//                 {/* Warehouse (Name looked up from warehouse ID) */}
//                 {!isFormOpen && (
//                   <div className="hidden lg:block flex-[1.2] text-left min-w-[120px] font-medium text-[#212121]/70">
//                     {getWarehouseName(item.warehouseId)}
//                   </div>
//                 )}

//                 {/* Shipments */}
//                 <div className="flex-[2] text-center min-w-[200px] flex items-center justify-around text-xs font-medium text-[#212121]/70">
//                   <span className="px-2 text-[#212121]">{totalShipments}</span>
//                   <span className="px-2 text-emerald-600">{del}</span>
//                   <span className="px-2 text-rose-500">{nd}</span>
//                   <span className="px-2 text-amber-600">{ofd}</span>
//                 </div>

//                 {/* COD */}
//                 {!isFormOpen && (
//                   <div className="flex-[0.8] flex items-center gap-2 justify-center text-center min-w-[80px] font-medium text-[#212121]/70">
//                     <img src="/img/riyal-icon.svg" alt="" /> {codTotal}
//                   </div>
//                 )}

//                 {/* Date & Time */}
//                 {!isFormOpen && (
//                   <div className="flex-[0.9] text-center min-w-[90px] text-xs text-[#212121]/70 font-medium">
//                     {formatDateReadable(item.createdAt)}
//                   </div>
//                 )}
//                 {!isFormOpen && (
//                   <div className="flex-[0.9] text-center min-w-[90px] text-xs text-[#212121]/70 font-medium">
//                     {item.createdBy}
//                   </div>
//                 )}

//                 {/* Status */}
//                 <div className="flex-[0.8] text-center min-w-[90px]">
//                   <span
//                     className={`px-2.5 py-0.5 rounded-full border text-[10px] font-semibold uppercase tracking-wider ${getStatusColor(item.status)}`}
//                   >
//                     {item.status?.toLowerCase()}
//                   </span>
//                 </div>

//                 {/* Print Actions */}
//                 <div
//                   className="flex-[0.8] text-center min-w-[100px] flex items-center justify-center"
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <button
//                     onClick={() => handlePrintDrs(item.drsId)}
//                     disabled={
//                       printingDrsId === item.drsId && downloadDrs.isPending
//                     }
//                     className="p-2 hover:bg-gray-100 rounded-full text-gray-600 transition-colors disabled:opacity-50"
//                   >
//                     {printingDrsId === item.drsId && downloadDrs.isPending ? (
//                       <span className="animate-spin block h-4 w-4 border-2 border-gray-500 border-t-transparent rounded-full" />
//                     ) : (
//                       <IconPrinter size={18} />
//                     )}
//                   </button>
//                 </div>
//               </div>

//               {/* Expanded Content View */}
//               {isExpanded && (
//                 <div className="border-t border-[#E5E5E5] bg-[#FAFAFA] sticky left-0 w-full max-w-[calc(100vw-32px)] md:max-w-[calc(100vw-80px)] lg:max-w-full">
//                   {/* Shipments Table Panel */}
//                   <div className="p-4">
//                     {(() => {
//                       const isAssignActive =
//                         openAssign &&
//                         swapRequest &&
//                         swapRequestData?.id === swapRequest?.id;
//                       const isAnyActive = isAssignActive;

//                       return (
//                         <div className="flex flex-col lg:flex-row gap-4 items-start w-full">
//                           {/* Table container */}
//                           <div
//                             className={`w-full bg-white rounded-xl border border-[#E5E5E5] overflow-visible ${isAnyActive ? "lg:max-w-[calc(100%-446px)] flex-1" : ""}`}
//                           >
//                             {/* Table header with title, search and action buttons */}
//                             <DRSExpandedShipments
//                               drsId={item.drsId}
//                               swaps={swaps}
//                               onRiw={() => onRiw(item)}
//                               onSwap={() => OnSwap(item)}
//                               swapRequest={swapRequest}
//                               onOpenSwapAssign={onOpenSwapAssign}
//                               openSwapMenuDrsId={openSwapMenuDrsId}
//                               setOpenSwapMenuDrsId={setOpenSwapMenuDrsId}
//                               swapMenuRef={
//                                 openSwapMenuDrsId === item.drsId
//                                   ? swapMenuRef
//                                   : undefined
//                               }
//                               drsItemId={item.drsId}
//                               selectedRows={selectedRows}
//                               setSelectedRows={setSelectedRows}
//                               selectedLines={selectedLines}
//                               setSelectedLines={setSelectedLines}
//                               handleSaveAllReturns={handleSaveAllReturns}
//                               isShipmentReturnPending={isShipmentReturnPending}
//                               handleGenerateSwap={handleGenerateSwap}
//                               isSwapGeneratePending={isSwapGeneratePending}
//                             />
//                           </div>

//                           {/* Inline Form Sidebar panel */}
//                           {isAnyActive && (
//                             <div className="w-full lg:w-[430px] shrink-0 space-y-3">
//                               {isAssignActive && (
//                                 <SwapDriverModal
//                                   open={openAssign}
//                                   onClose={onCloseAssign || (() => {})}
//                                   raiseReqDriverDriverRouteCode={
//                                     swapRequestData?.raiseReqDriverDriverRouteCode
//                                   }
//                                   excludeDriverId={
//                                     swapRequestData?.raiseReqDriverId
//                                   }
//                                   drsSwapId={swapRequestData?.id}
//                                   refetch={() => {
//                                     if (refetchMainList) refetchMainList();
//                                     if (refetchSwapsList) refetchSwapsList();
//                                   }}
//                                   isSidebar={true}
//                                   selectedLines={selectedLines}
//                                 />
//                               )}
//                             </div>
//                           )}
//                         </div>
//                       );
//                     })()}
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default DRSExpandableList;

import React, { useState } from "react";
import {
  IconArrowBackUp,
  IconArrowsLeftRight,
  IconBox,
  IconBuildingWarehouse,
  IconChevronDown,
  IconChevronUp,
  IconPrinter,
  IconReplaceUser,
  IconSearch,
  IconX,
} from "@tabler/icons-react";
import DRSShipmentPanel from "./DRSShipmentPanel";
import SwapGenrateModal from "./SwapGenrateModal";
import SwapDriverModal from "./SwapDriverModal";
import { useForm, Controller } from "react-hook-form";
import {
  useFetchDRSDetailsData,
  useDRSShipmentRevertStatusMutation,
  useDRSDownloadMutation,
} from "../../../apis/drsApi";
import { useWarehouseListData } from "../../../apis/warehouseApi";
import useDebounce from "../../../utilities/useDebounce";
import ListView from "../../../components/common/ListView";
import toast from "react-hot-toast";
import { T, useLanguage } from "../../../context/LanguageContext";
import { usePermission } from "../../../hooks/usePermissionTabs";
import formatDate from "../../../utilities/helper";

// Type definitions and helper functions (unchanged)
type DrsData = {
  id: number;
  drsId: string;
  driver: string;
  driverCode?: string;
  city: string;
  warehouseId?: string;
  warehouseName?: string;
  routeCode: string;
  createdAt: string;
  createdBy: string;
  codAmount: string;
  shipments: string;
  ordersDelivered: string;
  ordersNotDelivered: string;
  ordersProcess: string;
  collectedAmount: string;
  receiveInWarehouse: string;
  outForDelivery: string;
  status: string;
};

const formatStatus = (status: string) => {
  return status
    ?.toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// DRSExpandedShipments component (unchanged)
const DRSExpandedShipments: React.FC<{
  drsId: string;
  swaps?: any[];
  onRiw?: () => void;
  onSwap?: () => void;
  swapRequest?: any;
  onOpenSwapAssign?: (swapReq: any) => void;
  openSwapMenuDrsId?: string | null;
  setOpenSwapMenuDrsId?: (id: string | null) => void;
  swapMenuRef?: React.RefObject<HTMLDivElement | null>;
  drsItemId?: string;
  selectedRows: string[];
  setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
  selectedLines: string[];
  setSelectedLines: React.Dispatch<React.SetStateAction<string[]>>;
  handleSaveAllReturns?: () => void;
  isShipmentReturnPending?: boolean;
  handleGenerateSwap?: () => void;
  isSwapGeneratePending?: boolean;
}> = ({
  drsId,
  swaps = [],
  onRiw,
  onSwap,
  swapRequest,
  onOpenSwapAssign,
  openSwapMenuDrsId,
  setOpenSwapMenuDrsId,
  swapMenuRef,
  drsItemId,
  selectedRows,
  setSelectedRows,
  selectedLines,
  setSelectedLines,
  handleSaveAllReturns,
  isShipmentReturnPending,
  handleGenerateSwap,
  isSwapGeneratePending,
}) => {
  const { t } = useLanguage();
  const { allowed: canUpdateDrs } = usePermission("drs", "update");
  const { allowed: canUpdateSwap } = usePermission("drs_swap", "update");
  const [searchText, setSearchText] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);
  const debouncedSearch = useDebounce(searchText.trim().toLowerCase(), 400);

  const { data, isLoading, refetch } = useFetchDRSDetailsData(drsId, "DL");
  const { mutate: revertStatus, isPending: isRevertStatusPending } =
    useDRSShipmentRevertStatusMutation();

  const shipments = React.useMemo(() => {
    return data?.drs?.[0]?.shipments || [];
  }, [data]);

  const swapForShipment = React.useMemo(() => {
    const map: Record<
      string,
      {
        swapShortId: string;
        status: string;
        acceptReqDriverName?: string;
        rawSwap?: any;
      }
    > = {};
    if (swaps && Array.isArray(swaps)) {
      swaps.forEach((swap: any) => {
        if (
          swap.oldDrsShortId === drsId &&
          swap.shipmentIds &&
          Array.isArray(swap.shipmentIds)
        ) {
          swap.shipmentIds.forEach((sid: string) => {
            map[sid] = {
              swapShortId: swap.swapShortId,
              status: swap.status,
              acceptReqDriverName: swap.acceptReqDriverName,
              rawSwap: swap,
            };
          });
        }
      });
    }
    return map;
  }, [swaps, drsId]);

  const filteredShipments = React.useMemo(() => {
    if (!shipments) return [];
    if (!debouncedSearch) return shipments;
    return shipments.filter((shipment: any) => {
      const awb = shipment.awbNumber?.toLowerCase() || "";
      const receiverName = shipment.receiverName?.toLowerCase() || "";
      const receiverCity = shipment.receiverCity?.toLowerCase() || "";
      const receiverDistrict = shipment.receiverDistrict?.toLowerCase() || "";
      return (
        awb.includes(debouncedSearch) ||
        receiverName.includes(debouncedSearch) ||
        receiverCity.includes(debouncedSearch) ||
        receiverDistrict.includes(debouncedSearch)
      );
    });
  }, [shipments, debouncedSearch]);

  const isNotDeliveredStatus = (status: string) => {
    const s = (status || "").toUpperCase();
    return s === "NOT_DELIVERED" || s === "RETURNED";
  };

  const isEligibleForSwap = (s: any) => {
    const normStatus = (s.status || "").toUpperCase();
    const swapInfo = swapForShipment[s.id];
    const hasActiveSwap =
      swapInfo?.status === "REQUEST" ||
      swapInfo?.status === "ACCEPTED" ||
      s.isSwapped;
    return normStatus === "OUT_FOR_DELIVERY" && !hasActiveSwap;
  };

  const selectedShipments = React.useMemo(() => {
    return shipments.filter((s: any) => selectedRows.includes(s.id));
  }, [shipments, selectedRows]);

  const isRiwActive = React.useMemo(() => {
    return (
      selectedRows.length > 0 &&
      selectedShipments.every((s: any) => isNotDeliveredStatus(s.status))
    );
  }, [selectedRows, selectedShipments]);

  const riwTooltip = isRiwActive
    ? "Dispatch OFD / RIW"
    : "Select not delivered AWB";

  const isSwapActive = React.useMemo(() => {
    return (
      selectedLines.length > 0 &&
      selectedLines.every((id: string) => {
        const s = shipments.find((x: any) => x.id === id);
        return s && isEligibleForSwap(s);
      })
    );
  }, [selectedLines, shipments, swapForShipment]);

  const swapTooltip = isSwapActive ? "Generate Swap" : "Select AWB to Swap";

  const isAssignDriverActive = React.useMemo(() => {
    if (selectedRows.length === 0) return false;
    return selectedRows.every((id: string) => {
      const swapInfo = swapForShipment[id];
      return swapInfo?.status === "REQUEST";
    });
  }, [selectedRows, swapForShipment]);

  const assignDriverTooltip = React.useMemo(() => {
    if (selectedRows.length === 0) {
      return "Select swap request AWB";
    }
    const hasNonSwap = selectedRows.some((id: string) => {
      const swapInfo = swapForShipment[id];
      return swapInfo?.status !== "REQUEST";
    });
    if (hasNonSwap) {
      return "Only swap req shipment can be assign driver";
    }
    return "Swap Driver / Assign Driver";
  }, [selectedRows, swapForShipment]);

  const showSwapDriverButton = React.useMemo(() => {
    if (swapRequest?.status !== "REQUEST") return false;
    return (
      selectedRows.length > 0 &&
      selectedRows.some(
        (id: string) => swapForShipment[id]?.status === "REQUEST",
      )
    );
  }, [swapRequest, selectedRows, swapForShipment]);

  const handleRevertStatus = (shipmentId: string, shipmentStatus: string) => {
    if (!shipmentId || shipmentId.trim() === "") {
      toast.error("Invalid shipment ID");
      return;
    }
    if (shipmentStatus === "DELIVERED" || shipmentStatus === "NOT_DELIVERED") {
      toast.error(`Cannot revert ${shipmentStatus.replace(/_/g, " ")} orders`);
      return;
    }
    if (!data?.drs?.[0]?.id) {
      toast.error("DRS information is not available");
      return;
    }
    setOpenMenuId(null);
    const payload = { drsId: data?.drs?.[0]?.id, shipments: [shipmentId] };
    revertStatus(payload, {
      onSuccess: (res: any) => {
        refetch();
        toast.success(res?.message || "Status reverted successfully");
      },
      onError: (error: any) => {
        console.error(error);
        const errorMessage =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.message ||
          "Failed to revert status.";
        toast.error(errorMessage);
      },
    });
  };

  if (isLoading) {
    return (
      <div className="p-8 text-center text-sm font-medium text-gray-500">
        Loading shipments...
      </div>
    );
  }

  return (
    <div className="overflow-visible">
      {/* Table header row — styled like Order table */}
      <div className="flex items-center justify-between px-4 py-2.5 bg-white border-b border-[#E5E5E5]">
        {/* Left: title + swap badge */}
        <div className="flex items-center gap-3">
          <h3 className="text-sm font-bold text-[#212121]">{t("Shipments List")}</h3>
          {swapRequest && (
            <span className="px-2 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200 text-[10px] font-bold uppercase tracking-wider">
              {t("SWAP")}: {t(swapRequest.status)}
            </span>
          )}
        </div>

        {/* Right: slide-open search + action buttons */}
        <div className="flex items-center gap-2">
          {/* Slide-open Search — same as DRS list */}
          <div className="relative group">
            <div
              onClick={() => {
                if (!showSearch) setShowSearch(true);
              }}
              className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 shrink-0 ${
                showSearch
                  ? "w-56 px-2 cursor-default"
                  : "w-8 justify-center cursor-pointer"
              }`}
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSearch(!showSearch);
                }}
                className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
              >
                <IconSearch size={16} stroke={2.5} />
              </button>
              {showSearch && (
                <>
                  <input
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder={t("Search...")}
                    autoFocus
                    className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none border-0 focus:ring-0 focus:outline-none p-0"
                  />
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setSearchText("");
                      setShowSearch(false);
                    }}
                    className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                    title={t("Clear & Close")}
                  >
                    <IconX size={14} stroke={2.5} />
                  </button>
                </>
              )}
            </div>
            {!showSearch && (
              <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                {t("Search")}
              </div>
            )}
          </div>

          {/* Dispatch OFD / RIW button */}
          {handleSaveAllReturns && canUpdateDrs && (
            <div className="relative group">
              <button
                disabled={!isRiwActive || isShipmentReturnPending}
                onClick={handleSaveAllReturns}
                className="h-8 w-8 flex items-center justify-center bg-white border border-slate-200 text-slate-700 hover:bg-[#FBD037] hover:border-[#FBD037] hover:text-[#212121] rounded-md shadow-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-slate-700 disabled:hover:border-slate-200"
              >
                <IconBuildingWarehouse
                  size={16}
                  stroke={2.5}
                  className={isShipmentReturnPending ? "animate-pulse" : ""}
                />
              </button>
              <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                {t(riwTooltip)}
              </div>
            </div>
          )}

          {/* Generate Swap button */}
          {handleGenerateSwap && canUpdateSwap && (
            <div className="relative group">
              <button
                disabled={!isSwapActive || isSwapGeneratePending}
                onClick={handleGenerateSwap}
                className="h-8 w-8 flex items-center justify-center bg-white border border-slate-200 text-slate-700 hover:bg-[#FBD037] hover:border-[#FBD037] hover:text-[#212121] rounded-md shadow-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-slate-700 disabled:hover:border-slate-200"
              >
                <IconArrowsLeftRight
                  size={16}
                  stroke={2.5}
                  className={isSwapGeneratePending ? "animate-pulse" : ""}
                />
              </button>
              <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                {t(swapTooltip)}
              </div>
            </div>
          )}
          {/* Swap Driver button */}
          {showSwapDriverButton && onOpenSwapAssign && canUpdateSwap && (
            <div className="relative group">
              <button
                disabled={!isAssignDriverActive}
                onClick={(e) => {
                  e.stopPropagation();
                  const firstSelectedId = selectedRows[0];
                  const swapInfo = swapForShipment[firstSelectedId];
                  if (swapInfo && swapInfo.rawSwap) {
                    onOpenSwapAssign(swapInfo.rawSwap);
                  } else if (swapRequest) {
                    onOpenSwapAssign(swapRequest);
                  }
                }}
                className="h-8 w-8 flex items-center justify-center bg-white border border-slate-200 text-slate-700 hover:bg-[#FBD037] hover:border-[#FBD037] hover:text-[#212121] rounded-md shadow-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-slate-700 disabled:hover:border-slate-200"
              >
                <IconReplaceUser size={16} stroke={2.5} />
              </button>
              <div className="absolute bottom-full mb-1.5 right-0 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                {t(assignDriverTooltip)}
              </div>
            </div>
          )}
        </div>
      </div>

      <ListView
        mailDivClassName=" "
        mainDivClassName=""
        scrollbarClassName="custom-scrollbar"
        data={filteredShipments}
        columns={[
          {
            label: (
              <label className="relative flex items-center justify-center cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={
                    filteredShipments.length > 0 &&
                    filteredShipments.every((s: any) =>
                      selectedRows.includes(s.id),
                    )
                  }
                  onChange={(e) => {
                    const ids = filteredShipments.map((s: any) => s.id);
                    if (e.target.checked) {
                      setSelectedRows(ids);
                      setSelectedLines(ids);
                    } else {
                      setSelectedRows([]);
                      setSelectedLines([]);
                    }
                  }}
                  className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                />
                <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                  ✓
                </span>
              </label>
            ),
            render: (row: any) => (
              <div className="flex items-center justify-center">
                <label className="relative flex items-center cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row.id)}
                    onChange={() => {
                      const isChecked = selectedRows.includes(row.id);
                      if (isChecked) {
                        setSelectedRows((prev) =>
                          prev.filter((id) => id !== row.id),
                        );
                        setSelectedLines((prev) =>
                          prev.filter((id) => id !== row.id),
                        );
                      } else {
                        setSelectedRows((prev) => [...prev, row.id]);
                        setSelectedLines((prev) => [...prev, row.id]);
                      }
                    }}
                    className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                  />
                  <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    ✓
                  </span>
                </label>
              </div>
            ),
          },
          {
            label: t("AWB No."),
            render: (s: any) => {
              const swapInfo = swapForShipment[s.id];
              return (
                <div className="flex flex-col items-center gap-1 py-1">
                  <span>{s.awbNumber}</span>
                  {swapInfo && (
                    <div className="flex flex-col items-center gap-0.5">
                      <span
                        className={`inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider border leading-none ${
                          swapInfo.status === "REQUEST"
                            ? "bg-amber-50 text-amber-700 border-amber-200"
                            : swapInfo.status === "ACCEPTED"
                              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                              : "bg-gray-100 text-gray-700 border-gray-200"
                        }`}
                      >
                        {t("Swap")}: {t(swapInfo.status)}
                      </span>
                      {swapInfo.acceptReqDriverName && (
                        <span className="text-[9px] text-gray-500 font-medium leading-none">
                          &rarr; {swapInfo.acceptReqDriverName}
                        </span>
                      )}
                    </div>
                  )}
                  {s.isSwapped && (
                    <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider border leading-none bg-emerald-100 text-emerald-800 border-emerald-300">
                      {t("SWAPPED")}
                    </span>
                  )}
                </div>
              );
            },
          },
          { label: t("Origin"), render: (c: any) => c.senderCity },
          {
            label: t("Destination"),
            render: (s: any) => (
              <div className=" ">
                {s.receiverCity || s.receiverCityName || ""}
                {s.receiverCountry || s.receiverCountryName
                  ? `, ${s.receiverCountry || s.receiverCountryName}`
                  : ""}
              </div>
            ),
          },
          {
            label: t("District"),
            render: (s: any) => (
              <div>{s.receiverDistrict || s.receiverDistrictName || "N/A"}</div>
            ),
          },
          {
            label: t("Payment"),
            render: (s: any) => (
              <div className="text-center">
                <span
                  className={`px-1.5 py-0.5 rounded text-[10px] font-black tracking-wider uppercase border inline-block max-w-full ${
                    s.paymentType === "COD"
                      ? "bg-amber-50 border-amber-200 text-amber-800"
                      : "bg-emerald-50 border-emerald-200 text-emerald-800"
                  }`}
                >
                  {" "}
                  {s.paymentType === "COD"
                    ? `${t("COD")}: ${s.codAmount ?? 0}`
                    : t("CC: PAID")}
                </span>
              </div>
            ),
          },
          {
            label: t("Status"),
            render: (c: any) => {
              const normStatus = (c.status || "").toUpperCase();
              let badgeClasses =
                "bg-slate-50 border border-slate-200 text-slate-600";
              let label = formatStatus(c.status);

              if (normStatus === "DELIVERED") {
                badgeClasses =
                  "bg-lime-50 border border-lime-300 text-lime-800";
                label = t("Delivered");
              } else if (normStatus === "OUT_FOR_DELIVERY") {
                badgeClasses =
                  "bg-orange-50 border border-orange-300 text-orange-800";
                label = t("Out For Delivery");
              } else if (normStatus === "DELETED") {
                badgeClasses =
                  "bg-rose-50 border border-rose-300 text-rose-800";
                label = t("Deleted");
              } else if (
                normStatus === "NOT_DELIVERED" ||
                normStatus === "RETURNED"
              ) {
                badgeClasses =
                  "bg-rose-50 border border-rose-300 text-rose-800";
                label = t("Not Delivered");
              } else {
                label = t(label);
              }

              return (
                <div className="text-center">
                  <span
                    className={`border py-0.5 rounded-full text-[10px] font-extrabold tracking-wide inline-block text-center px-2 truncate max-w-full align-middle ${badgeClasses}`}
                  >
                    {label}
                  </span>
                </div>
              );
            },
          },
          {
            label: t("Revert Status"),
            render: (c: any) => {
              if (c.status === "DELIVERED" || c.status === "NOT_DELIVERED") {
                return null;
              }

              return (
                <div className="text-center">
                  <button
                    onClick={() => handleRevertStatus(c.id, c.status)}
                    disabled={isRevertStatusPending}
                    className="p-1.5 bg-rose-50 hover:bg-rose-100 border border-rose-200 text-rose-600 rounded-full text-xs font-bold transition shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
                  >
                    <IconArrowBackUp />
                  </button>
                </div>
              );
            },
          },
        ]}
      />
    </div>
  );
};

// Main DRSExpandableList component with new UI (chevron removed)
type Props = {
  data: DrsData[];
  onRiw: (item: DrsData) => void;
  OnSwap: (item: DrsData) => void;
  onEdit?: (item: DrsData) => void;
  selectedData: any[];
  setSelectedData: React.Dispatch<React.SetStateAction<any[]>>;
  isDownloadMode: boolean;
  onExpandRow?: (drsId: string | null) => void;
  swaps?: any[];
  onOpenSwapAssign?: (swapReq: any) => void;
  isFormOpen?: boolean;

  // Sidebar props
  openFlet?: boolean;
  swap?: boolean;
  openAssign?: boolean;
  activeDrsId?: string;
  activeDrsShortId?: string;
  swapRequestData?: any;

  returnForm?: any;
  selectedRows?: string[];
  setSelectedRows?: any;
  savedReturns?: any;
  setSavedReturns?: any;
  isShipmentReturnPending?: boolean;
  handleSaveAllReturns?: () => void;
  openFletToggleModal?: () => void;

  register?: any;
  errors?: any;
  clearErrors?: any;
  setValue?: any;
  control?: any;
  watch?: any;
  selectedLines?: string[];
  setSelectedLines?: any;
  isSwapGeneratePending?: boolean;
  handleGenerateSwap?: () => void;
  openSwapGenrateModal?: () => void;

  refetchMainList?: () => void;
  refetchSwapsList?: () => void;
  onCloseAssign?: () => void;
};

const formatDateReadable = (dateStr: string) => {
  if (!dateStr) return "—";
  try {
    const d = new Date(dateStr);
    const day = d.getDate();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[d.getMonth()];
    const year = d.getFullYear();
    return `${day} ${month} ${year}`;
  } catch (e) {
    return dateStr;
  }
};

const DRSExpandableList: React.FC<Props> = ({
  data = [],
  onRiw,
  OnSwap,
  onEdit,
  selectedData,
  setSelectedData,
  isDownloadMode,
  onExpandRow,
  swaps = [],
  onOpenSwapAssign,
  isFormOpen = false,

  openFlet = false,
  swap: openSwap = false,
  openAssign = false,
  activeDrsId = "",
  activeDrsShortId = "",
  swapRequestData,

  returnForm,
  selectedRows = [],
  setSelectedRows,
  savedReturns = {},
  setSavedReturns,
  isShipmentReturnPending = false,
  handleSaveAllReturns,
  openFletToggleModal,

  register,
  errors,
  clearErrors,
  setValue,
  control,
  watch,
  selectedLines = [],
  setSelectedLines,
  isSwapGeneratePending = false,
  handleGenerateSwap,
  openSwapGenrateModal,

  refetchMainList,
  refetchSwapsList,
  onCloseAssign,
}) => {
  const { t } = useLanguage();
  const { data: warehousesData } = useWarehouseListData();
  const downloadDrs = useDRSDownloadMutation();
  const [printingDrsId, setPrintingDrsId] = useState<string | null>(null);

  const handlePrintDrs = (drsId: string) => {
    setPrintingDrsId(drsId);
    downloadDrs.mutate(drsId, {
      onSuccess: () => {
        toast.success("DRS Sheet PDF downloaded successfully");
        setPrintingDrsId(null);
      },
      onError: (err: any) => {
        const errMsg = err?.message || "Failed to download DRS Sheet";
        toast.error(errMsg);
        setPrintingDrsId(null);
      },
    });
  };

  const getWarehouseName = (warehouseId?: string) => {
    if (!warehouseId || !warehousesData?.warehouses) return "—";
    const found = warehousesData.warehouses.find(
      (w: any) => w.id === warehouseId,
    );
    return found ? found.name : "—";
  };

  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const [openSwapMenuDrsId, setOpenSwapMenuDrsId] = useState<string | null>(
    null,
  );
  const swapMenuRef = React.useRef<HTMLDivElement>(null);
  const [openActionMenuId, setOpenActionMenuId] = useState<string | null>(null);
  const actionMenuRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        openSwapMenuDrsId &&
        swapMenuRef.current &&
        !swapMenuRef.current.contains(event.target as Node)
      ) {
        setOpenSwapMenuDrsId(null);
      }
      if (
        openActionMenuId &&
        actionMenuRef.current &&
        !actionMenuRef.current.contains(event.target as Node)
      ) {
        setOpenActionMenuId(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openSwapMenuDrsId, openActionMenuId]);

  const handleRowClick = (item: DrsData) => {
    const isExpanded = expandedRow === item.drsId;
    const nextVal = isExpanded ? null : item.drsId;
    setExpandedRow(nextVal);
    if (onExpandRow) {
      onExpandRow(nextVal);
    }
  };

  const handleRowSelect = (item: DrsData, checked: boolean) => {
    if (checked) {
      setSelectedData((prev) => {
        if (!prev.some((d) => d.drsId === item.drsId)) {
          return [...prev, item];
        }
        return prev;
      });
    } else {
      setSelectedData((prev) => prev.filter((d) => d.drsId !== item.drsId));
    }
  };

  // Status badge for DRS
  const getDRSStatusBadge = (status: string) => {
    const norm = (status || "").toUpperCase();
    if (norm === "ACTIVE") {
      return {
        label: "Active",
        className: "bg-green-50 border border-green-300 text-green-800",
      };
    } else if (norm === "CLOSED") {
      return {
        label: "Closed",
        className: "bg-slate-50 border border-slate-300 text-slate-700",
      };
    } else {
      return {
        label: status || "Unknown",
        className: "bg-blue-50 border border-blue-300 text-blue-800",
      };
    }
  };

  // Compute column widths for colgroup (no chevron)
  const getColumnWidths = () => {
    const widths: Record<string, string> = {};
    // Checkbox (if download mode)
    if (isDownloadMode) widths["checkbox"] = "3%";
    // DRS ID
    widths["drsId"] = "9%";
    // Driver
    widths["driver"] = "11%";
    // Driver Code
    widths["driverCode"] = "10%";
    // City
    widths["city"] = "7%";
    // Route Code
    widths["route"] = "6%";
    // Warehouse
    widths["warehouse"] = "9%";
    // Shipment stats (4 columns)
    widths["total"] = "4%";
    widths["delivered"] = "4%";
    widths["returned"] = "4%";
    widths["inProcess"] = "4%";
    // COD
    widths["cod"] = "6%";
    // Date
    widths["date"] = "6%";
    // Created By
    widths["createdBy"] = "6%";
    // Status
    widths["status"] = "7%";
    // Print
    widths["print"] = "12%";
    return widths;
  };

  const colWidths = getColumnWidths();

  // Determine number of columns for colspan in expanded row
  const totalColumns = () => {
    let count = 0;
    if (isDownloadMode) count++; // checkbox
    count++; // drsId
    count++; // driver
    count++; // driverCode
    count++; // city
    count++; // route
    count++; // warehouse
    count += 4; // total, del, ret, inprocess
    count++; // cod
    count++; // date
    count++; // createdBy
    count++; // status
    count++; // print
    return count;
  };

  return (
    <div className="overflow-y-auto overflow-x-auto max-h-[75vh] custom-scrollbar bg-[#FCFDF8] rounded-b-3xl  shadow-inner">
      {data.length === 0 ? (
        <div className="py-16 text-center">
          <p className="text-slate-400 text-sm font-semibold">
            No DRS records found
          </p>
        </div>
      ) : (
        <table
          className="w-full text-left border-collapse table-fixed"
          style={{ minWidth: "1400px" }}
        >
          <colgroup>
            {isDownloadMode && <col style={{ width: colWidths["checkbox"] }} />}
            <col style={{ width: colWidths["drsId"] }} />
            <col style={{ width: colWidths["driver"] }} />
            <col style={{ width: colWidths["driverCode"] }} />
            <col style={{ width: colWidths["city"] }} />
            <col style={{ width: colWidths["route"] }} />
            <col style={{ width: colWidths["warehouse"] }} />
            <col style={{ width: colWidths["total"] }} />
            <col style={{ width: colWidths["delivered"] }} />
            <col style={{ width: colWidths["returned"] }} />
            <col style={{ width: colWidths["inProcess"] }} />
            <col style={{ width: colWidths["cod"] }} />
            <col style={{ width: colWidths["date"] }} />
            <col style={{ width: colWidths["createdBy"] }} />
            <col style={{ width: colWidths["status"] }} />
            <col style={{ width: colWidths["print"] }} />
          </colgroup>

          <thead className="text-[#131327]/70 border-b border-dashed border-gray-300 sticky top-0 z-20 bg-[#FCFDF8]">
            <tr className="text-center text-[11px] font-semibold tracking-wider uppercase select-none">
              {isDownloadMode && (
                <th className="px-2 pt-3 pb-2 border-r border-dashed border-gray-200">
                  <div className="flex items-center justify-center">
                    <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                      <input
                        type="checkbox"
                        checked={
                          data.length > 0 && selectedData.length === data.length
                        }
                        onChange={(e) => {
                          const checked = e.target.checked;
                          data.forEach((item) => {
                            const isSelected = selectedData.some(
                              (d) => d.drsId === item.drsId,
                            );
                            if (checked && !isSelected)
                              handleRowSelect(item, true);
                            else if (!checked && isSelected)
                              handleRowSelect(item, false);
                          });
                        }}
                        className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                      />
                      <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                        ✓
                      </span>
                    </label>
                  </div>
                </th>
              )}
              <th className="px-2 pt-4 border-r border-dashed border-gray-200">
                {t("DRS ID")}
              </th>
              <th
                colSpan={2}
                className="px-2  border-r border-dashed border-gray-200"
              >
                {t("Driver")}
              </th>
              <th className="px-2 pt-4  border-r border-dashed border-gray-200">
                {t("Warehouse")}
              </th>
              <th className="px-2 pt-4 border-r border-dashed border-gray-200">
                {t("City")}
              </th>
              <th className="px-2 pt-4 border-r border-dashed border-gray-200">
                {t("Route")}
              </th>
              <th
                colSpan={4}
                className="px-2  border-r border-dashed border-gray-200 text-center"
              >
                {t("Shipment")}
              </th>
              <th className="px-2 pt-4 border-r border-dashed border-gray-200">
                {t("COD")}
              </th>
              <th className="px-2 pt-4 border-r border-dashed border-gray-200">
                {t("Date")}
              </th>
              <th className="px-2 pt-4 border-r border-dashed border-gray-200">
                {t("Created By")}
              </th>
              <th className="px-2 pt-4 border-r border-dashed border-gray-200">
                {t("Status")}
              </th>
              <th className="px-2 pt-4">{t("Print")}</th>
            </tr>
            <tr className="text-center text-[10px] font-semibold tracking-wider uppercase select-none bg-[#FCFDF8]">
              {isDownloadMode && <th className="px-2"></th>}
              <th className="px-2 border-r border-dashed border-gray-200"></th>
              <th className="px-2 py-0.5 border-t border-l border-r border-dashed border-gray-200 text-center text-[#131327]/60">
                {t("Name")}
              </th>
              <th className="px-2 py-0.5 border-t border-r border-dashed border-gray-200 text-center text-[#131327]/60">
                {t("Code")}
              </th>
              <th className="px-2 border-r border-dashed border-gray-200"></th>
              <th className="px-2 border-r border-dashed border-gray-200"></th>
              <th className="px-2  border-r border-dashed border-gray-200"></th>
              <th className="px-2 border-t border-l border-r border-dashed border-gray-200 text-center text-[#131327]/60">
                {t("TOTAL")}
              </th>
              <th className="px-2 border-t border-r border-dashed border-gray-200 text-center text-[#131327]/60">
                {t("INPROCESS")}
              </th>
              <th className="px-2 border-t border-r border-dashed border-gray-200 text-center text-[#131327]/60">
                {t("DELIVERED")}
              </th>
              <th className="px-2 border-t border-r border-dashed border-gray-200 text-center text-[#131327]/60">
                {t("NOT DEL")}
              </th>
              <th className="px-2 border-r border-dashed border-gray-200"></th>
              <th className="px-2 border-r border-dashed border-gray-200"></th>
              <th className="px-2 border-r border-dashed border-gray-200"></th>
              <th className="px-2 border-r border-dashed border-gray-200"></th>
              <th className="px-2"></th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 bg-white">
            {data.map((item, index) => {
              const isExpanded = expandedRow === item.drsId;
              const totalShipments = item.shipments?.length || 0;
              const del = parseInt(item.ordersDelivered) || 0;
              const nd = parseInt(item.ordersNotDelivered) || 0;
              const ofd = totalShipments - (del + nd);
              const codTotal = item.codAmount || 0;
              const swapRequest = swaps?.find(
                (s: any) => s.oldDrsShortId === item.drsId,
              );
              const isSelected = selectedData.some(
                (d) => d.drsId === item.drsId,
              );

              return (
                <React.Fragment key={item.id}>
                  <tr
                    className={`hover:bg-[#FBD037]/10  group transition-colors duration-150 cursor-pointer ${
                      isSelected ? "bg-amber-50/40" : ""
                    }`}
                    onClick={() => handleRowClick(item)}
                  >
                    {/* Checkbox */}
                    {isDownloadMode && (
                      <td
                        className="px-2 py-3 text-center"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) =>
                              handleRowSelect(item, e.target.checked)
                            }
                            className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                          />
                          <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                            ✓
                          </span>
                        </label>
                      </td>
                    )}

                    {/* DRS ID */}
                    <td className="px-2 py-3 text-xs font-medium text-[#212121] text-center ">
                      {item.drsId}
                    </td>

                    {/* Driver */}
                    {/* <td className="px-2 py-3 text-xs text-center">
                      <div className="font-bold text-[#212121]">
                        {item.driver || "—"}
                      </div>
                      {item.driverCode && (
                        <div className="text-[10px] text-slate-500 font-medium mt-0.5">
                          Code: {item.driverCode}
                        </div>
                      )}
                    </td> */}

                    <td className="px-2 py-3 text-xs font-medium text-[#212121] text-center">
                      {item.driver}
                    </td>
                    <td className="px-2 py-3 text-xs font-medium text-[#212121] text-center">
                      {item.driverCode}
                    </td>
                    <td className="px-2 py-3 text-xs font-medium text-[#212121]  text-center">
                      {getWarehouseName(item.warehouseId)}
                    </td>
                    {/* City */}
                    <td className="px-2 py-3 text-xs font-medium text-[#212121]  text-center">
                      {item.city || "—"}
                    </td>

                    {/* Route Code */}
                    <td className="px-2 py-3 text-xs font-medium text-[#212121]  text-center">
                      {item.routeCode || "—"}
                    </td>

                    {/* Warehouse */}

                    {/* Shipment stats */}
                    
                    <td className="px-2 py-3 text-center text-xs font-bold text-[#212121]">
                      {totalShipments}
                    </td>
                    <td className="px-2 py-3 text-center text-xs font-bold text-amber-600">
                      {ofd}
                    </td>
                    <td className="px-2 py-3 text-center text-xs font-bold text-emerald-600">
                      {del}
                    </td>
                    <td className="px-2 py-3 text-center text-xs font-bold text-rose-500">
                      {nd}
                    </td>

                    {/* COD */}
                    <td className="px-2 py-3 text-center text-xs font-medium text-[#212121]">
                      <div className="flex items-center justify-center gap-1">
                        <img
                          src="/img/riyal-icon.svg"
                          alt="SAR"
                          className="w-3 h-3"
                        />
                        {codTotal}
                      </div>
                    </td>

                    {/* Date */}
                    <td className="px-2 py-3 text-center text-xs font-medium text-[#212121]">
                      {formatDate(item.createdAt)}
                    </td>

                    {/* Created By */}
                    <td className="px-2 py-3 text-center text-xs font-medium text-[#212121]">
                      {item.createdBy || "—"}
                    </td>

                    {/* Status */}
                    <td className="px-2 py-3 text-center">
                      {(() => {
                        const badge = getDRSStatusBadge(item.status);
                        return (
                          <span
                            className={`border py-0.5 rounded-full text-[10px] font-extrabold tracking-wide inline-block text-center px-2 truncate max-w-full align-middle ${badge.className}`}
                          >
                            {t(badge.label)}
                          </span>
                        );
                      })()}
                    </td>

                    {/* Print */}
                    <td className="px-2 py-3 text-center">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePrintDrs(item.drsId);
                        }}
                        disabled={
                          printingDrsId === item.drsId && downloadDrs.isPending
                        }
                        className="p-2 hover:bg-gray-100 rounded-full text-gray-600 transition-colors disabled:opacity-50"
                      >
                        {printingDrsId === item.drsId &&
                        downloadDrs.isPending ? (
                          <span className="animate-spin block h-4 w-4 border-2 border-gray-500 border-t-transparent rounded-full" />
                        ) : (
                          <IconPrinter size={18} />
                        )}
                      </button>
                    </td>
                  </tr>

                  {/* Expanded row */}
                  {isExpanded && (
                    <tr className="bg-transparent border-none">
                      <td
                        colSpan={totalColumns()}
                        className="px-0 py-1 bg-slate-50"
                      >
                        {/* <DRSExpandedShipments
                          drsId={item.drsId}
                          swaps={swaps}
                          onRiw={() => onRiw(item)}
                          onSwap={() => OnSwap(item)}
                          swapRequest={swapRequest}
                          onOpenSwapAssign={onOpenSwapAssign}
                          openSwapMenuDrsId={openSwapMenuDrsId}
                          setOpenSwapMenuDrsId={setOpenSwapMenuDrsId}
                          swapMenuRef={
                            openSwapMenuDrsId === item.drsId
                              ? swapMenuRef
                              : undefined
                          }
                          drsItemId={item.drsId}
                          selectedRows={selectedRows}
                          setSelectedRows={setSelectedRows}
                          selectedLines={selectedLines}
                          setSelectedLines={setSelectedLines}
                          handleSaveAllReturns={handleSaveAllReturns}
                          isShipmentReturnPending={isShipmentReturnPending}
                          handleGenerateSwap={handleGenerateSwap}
                          isSwapGeneratePending={isSwapGeneratePending}
                        /> */}
                         <div className="p-">
                        {(() => {
                          const isAssignActive =
                            openAssign &&
                            swapRequest &&
                            swapRequestData?.id === swapRequest?.id;
                          const isAnyActive = isAssignActive;

                          return (
                            <div className="flex flex-col lg:flex-row gap-4 items-start w-full">
                              {/* Table container */}
                              <div
                                className={`w-full bg-white rounded-xl  overflow-visible ${isAnyActive ? "lg:max-w-[calc(100%-446px)] flex-1" : ""}`}
                              >
                                {/* Table header with title, search and action buttons */}
                                <DRSExpandedShipments
                                  drsId={item.drsId}
                                  swaps={swaps}
                                  onRiw={() => onRiw(item)}
                                  onSwap={() => OnSwap(item)}
                                  swapRequest={swapRequest}
                                  onOpenSwapAssign={onOpenSwapAssign}
                                  openSwapMenuDrsId={openSwapMenuDrsId}
                                  setOpenSwapMenuDrsId={setOpenSwapMenuDrsId}
                                  swapMenuRef={
                                    openSwapMenuDrsId === item.drsId
                                      ? swapMenuRef
                                      : undefined
                                  }
                                  drsItemId={item.drsId}
                                  selectedRows={selectedRows}
                                  setSelectedRows={setSelectedRows}
                                  selectedLines={selectedLines}
                                  setSelectedLines={setSelectedLines}
                                  handleSaveAllReturns={handleSaveAllReturns}
                                  isShipmentReturnPending={
                                    isShipmentReturnPending
                                  }
                                  handleGenerateSwap={handleGenerateSwap}
                                  isSwapGeneratePending={isSwapGeneratePending}
                                />
                              </div>

                              {/* Inline Form Sidebar panel */}
                              {isAnyActive && (
                                <div className="w-full lg:w-[430px] shrink-0 space-y-3">
                                  {isAssignActive && (
                                    <SwapDriverModal
                                      open={openAssign}
                                      onClose={onCloseAssign || (() => {})}
                                      raiseReqDriverDriverRouteCode={
                                        swapRequestData?.raiseReqDriverDriverRouteCode
                                      }
                                      excludeDriverId={
                                        swapRequestData?.raiseReqDriverId
                                      }
                                      drsSwapId={swapRequestData?.id}
                                      refetch={() => {
                                        if (refetchMainList) refetchMainList();
                                        if (refetchSwapsList)
                                          refetchSwapsList();
                                      }}
                                      isSidebar={true}
                                      selectedLines={selectedLines}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                      </td>
                    </tr>
                  )}

                  {/* {isExpanded && (
                    <div className="border-t border-[#E5E5E5] bg-[#FAFAFA] sticky left-0 w-full "> 
                      <div className="p-4">
                        {(() => {
                          const isAssignActive =
                            openAssign &&
                            swapRequest &&
                            swapRequestData?.id === swapRequest?.id;
                          const isAnyActive = isAssignActive;

                          return (
                            <div className="flex flex-col lg:flex-row gap-4 items-start w-full"> 
                              <div
                                className={`w-full bg-white rounded-xl border border-[#E5E5E5] overflow-visible ${isAnyActive ? "lg:max-w-[calc(100%-446px)] flex-1" : ""}`}
                              > 
                                <DRSExpandedShipments
                                  drsId={item.drsId}
                                  swaps={swaps}
                                  onRiw={() => onRiw(item)}
                                  onSwap={() => OnSwap(item)}
                                  swapRequest={swapRequest}
                                  onOpenSwapAssign={onOpenSwapAssign}
                                  openSwapMenuDrsId={openSwapMenuDrsId}
                                  setOpenSwapMenuDrsId={setOpenSwapMenuDrsId}
                                  swapMenuRef={
                                    openSwapMenuDrsId === item.drsId
                                      ? swapMenuRef
                                      : undefined
                                  }
                                  drsItemId={item.drsId}
                                  selectedRows={selectedRows}
                                  setSelectedRows={setSelectedRows}
                                  selectedLines={selectedLines}
                                  setSelectedLines={setSelectedLines}
                                  handleSaveAllReturns={handleSaveAllReturns}
                                  isShipmentReturnPending={
                                    isShipmentReturnPending
                                  }
                                  handleGenerateSwap={handleGenerateSwap}
                                  isSwapGeneratePending={isSwapGeneratePending}
                                />
                              </div>
 
                              {isAnyActive && (
                                <div className="w-full lg:w-[430px] shrink-0 space-y-3">
                                  {isAssignActive && (
                                    <SwapDriverModal
                                      open={openAssign}
                                      onClose={onCloseAssign || (() => {})}
                                      raiseReqDriverDriverRouteCode={
                                        swapRequestData?.raiseReqDriverDriverRouteCode
                                      }
                                      excludeDriverId={
                                        swapRequestData?.raiseReqDriverId
                                      }
                                      drsSwapId={swapRequestData?.id}
                                      refetch={() => {
                                        if (refetchMainList) refetchMainList();
                                        if (refetchSwapsList)
                                          refetchSwapsList();
                                      }}
                                      isSidebar={true}
                                      selectedLines={selectedLines}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    </div>
                  )} */}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DRSExpandableList;
